import Vue from "vue";
import VueRouter from "vue-router";
import DocumentoParceriaSCR from "../views/documento/DocumentoParceriaSCR.vue";
import DocumentoNagroSCR from "../views/documento/DocumentoNagroSCR.vue";
import UploadDoc from "../views/UploadDoc.vue";
import Confirmacao from "../views/Confirmacao.vue";
import paginaFinal from "../views/PaginaFinal.vue";
import Login from "../views/autenticacao/Login.vue";
import CadastroProdutor from "../views/autenticacao/CadastroProdutor.vue";
import ListagemProdutor from "../views/autenticacao/ListagemProdutor.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/autorizacao/:producer_data",
    name: "documentoParceria",
    component: DocumentoParceriaSCR
  },
  {
    path: "/autorizacao-nagro/:client_id",
    name: "documentoNagro",
    component: DocumentoNagroSCR
  },
  {
    path: "/upload",
    name: "uploadDoc",
    component: UploadDoc
  },
  {
    path: "/confirmacao",
    name: "confirmacao",
    component: Confirmacao
  },
  {
    path: "/paginaFinal",
    name: "final",
    component: paginaFinal
  },
  {
    path: "/",
    name: "login",
    component: Login
  },
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/cadastroProdutor",
    name: "cadastroProdutor",
    component: CadastroProdutor
  },
  {
    path: "/listagemProdutor",
    name: "listagemProdutor",
    component: ListagemProdutor
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
